import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Form, Alert } from "react-bootstrap";

const Header = ({ setOfficeId }) => {
  const [tenantName, setTenantName] = useState("");
  const [officeList, setOfficeList] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => {
    fetchOffices();
    loadDefaultTenant();
  }, []);

  const loadDefaultTenant = () => {
    const defaultTenantId = localStorage.getItem("defaultTenantId");
    if (defaultTenantId) {
      setTenantName(defaultTenantId);
      setOfficeId(defaultTenantId);
    }
  };

  const fetchOffices = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found, please log in.");
        return;
      }
      const response = await axios.get("https://housys.skymarkone.in:8001/api/getoffice", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data && response.data.office) {
        setOfficeList(response.data.office);
      } else {
        console.error("Error fetching offices:", response.data.msg);
      }
    } catch (error) {
      console.error("Error fetching offices:", error.response?.data || error.message);
    }
  };

  const handleTenantChange = (e) => {
    const selectedTenant = e.target.value;
    setTenantName(selectedTenant);
    
    if (selectedTenant) {
      setOfficeId(selectedTenant); // Automatically set the selected office_id
      
      // Automatically set as default
      localStorage.setItem("defaultTenantId", selectedTenant);
      setAlertMessage("Tenant selected and set as default!");
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
    } else {
      // Clear default if no tenant selected
      localStorage.removeItem("defaultTenantId");
      setOfficeId("");
    }
  };

  return (
    <div className="">
      {/* Alert Section */}
      {showAlert && (
        <div className="row mb-3">
          <div className="col-12">
            <Alert 
              variant="success" 
              dismissible 
              onClose={() => setShowAlert(false)}
              style={{
                borderRadius: "10px",
                border: "none",
                boxShadow: "0 4px 15px rgba(40, 167, 69, 0.2)",
                marginTop: "-8.5px"
              }}
            >
              <div className="d-flex align-items-center">
                <i className="bi bi-check-circle-fill me-2"></i>
                {alertMessage}
              </div>
            </Alert>
          </div>
        </div>
      )}

      {/* Simplified Header with Only Tenant Selection */}
      <div className="row">
        <div className="col-12">
          <div className="card shadow-sm border-0" style={{
            border: "none",
            border: "2px solid #dee2e6",
            borderRadius: "15px",
            background: "#ffffff",
            marginTop: showAlert ? "0" : "-8.5px"
          }}>
            <div className="card-body p-3">
              <div className="row align-items-center">
                {/* Welcome Text - Left Side */}
                <div className="col-md-6 d-flex flex-column align-items-start">
                  <h5 className="mb-0" style={{
                    background: "linear-gradient(45deg, #664CBE, #4472C4)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    fontWeight: "bold",
                    fontSize: "1.8rem"
                  }}>
                    Skymark One - Parking Management System
                  </h5>
                </div>

                {/* Tenant Selection - Right Side */}
                <div className="col-md-6">
                  <Form.Group controlId="formTenant" className="mb-0 d-flex flex-column align-items-end">
                    
                    <Form.Control
                      as="select"
                      value={tenantName}
                      onChange={handleTenantChange}
                      style={{
                        borderRadius: "10px",
                        border: "2px solid #e9ecef",
                        boxShadow: "none",
                        padding: "10px 16px",
                        fontWeight: "600",
                        fontSize: "1rem",
                        transition: "all 0.3s ease",
                        width: "140px", // Fixed width
                        maxWidth: "100%" // Responsive on smaller screens
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#664CBE";;
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#e9ecef";
                      }}
                    >
                      <option value="">Select Tenant</option>
                      {officeList.map((office, index) => (
                        <option key={index} value={office.office_id}>
                          {office.office_name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
